export default __webpack_public_path__ + "static/media/add-product.6cc53b27.png";